import Button from "components/button";
import LoginView from "components/layout/login-view";
import { useNavigate } from "react-router";

const AdminSignicatErrorView = () => {
  const navigate = useNavigate();

  const tryAgain = () => {
    navigate("/admin/login");
  };

  return (
    <LoginView title="Kirjautuminen epäonnistui" transition={false}>
      <Button type="primary" onClick={tryAgain}>
        Kirjaudu uudelleen
      </Button>
    </LoginView>
  );
};

export default AdminSignicatErrorView;
